<template>
  <div class="app-container">
    <navigation title="专题栏目"></navigation>
    <div class="app-project">
      <div class="notice">
        <van-cell title="专题展览" is-link :to="{name:'projectList',query:{title:'专题展览'}}" center>
          <template #right-icon>
            <div>
              <span class="more-val">更多</span>
<!--              <img src="@/assets/img/more.png" alt="" class="more">-->
            </div>
          </template>
        </van-cell>
        <ul class="oInformation" v-for="item in specialList" @click="goDetail(item.id)">
          <li class="project-title">{{ item.title }}</li>
          <li class="project-img"><img :src="item.coverPath" alt=""></li>
          <li class="date">{{ item.createTime }}</li>
        </ul>
      </div>
      <div class="notice collect">
        <van-cell title="在线展览" is-link :to="{name:'projectList',query:{title:'在线展览'}}" center>
          <template #right-icon>
            <div>
              <span class="more-val">更多</span>
<!--              <img src="@/assets/img/more.png" alt="" class="more">-->
            </div>
          </template>
        </van-cell>
        <ul class="oInformation" v-for="item in onlineList" @click="goDetail(item.id)">
          <li class="project-title">{{ item.title }}</li>
          <li class="project-img"><img :src="item.coverPath" alt=""></li>
          <li class="date">{{ item.createTime }}</li>
        </ul>
      </div>
    </div>
    <version></version>
  </div>
</template>

<script>
import Vue from 'vue'
import { Tabbar, TabbarItem, NavBar, Cell, CellGroup } from 'vant'
import { request } from '../../untils/request'
import navigation from '../../components/navigation'
import version from '../../components/version'

Vue.use(Tabbar).use(TabbarItem).use(NavBar).use(Cell).use(CellGroup)

export default {
  name: 'project',
  components: {navigation, version},
  data () {
    return {
      params: {
        pageNum: '1',
        pageSize: '2'
      },
      specialList: [],
      onlineList: []
    }
  },
  created () {
    // 专题栏目
    this.getSpecial()
    // 在线栏目
    this.getOnline()
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    getSpecial () {
      this.params.type = 'SPECIAL_EXHIBITION'
      request('get', '/nlc-web/api/special', this.params).then(res => {
        console.log('专题栏目', res)
        this.specialList = res.data.content
      })
    },
    getOnline () {
      this.params.type = 'ONLINE_EXHIBITION'
      request('get', '/nlc-web/api/special', this.params).then(res => {
        console.log('在线展览', res)
        this.onlineList = res.data.content
      })
    },
    // 去详情
    goDetail (id) {
      this.$router.push({name: 'articleDetails', params: {id: id}})
    }
  }
}
</script>

<style scoped>
.app-container{
  overflow-y:scroll;
  background:#ecf5fd;
  min-height: calc(100% - .92rem);
  position: absolute;
  top: 0px;
  bottom: 0px;
}
.more{
  width:.13rem;
  height:.24rem;
  vertical-align: middle;
}
.more-val{
  color:#008095;
  font-size:.24rem;
}
.app-project{
  width:6.94rem;
  margin:1.18rem .28rem .16rem .28rem;
}
.project-title{
  font-size:.24rem;
  line-height:.42rem;
}
.project-img{
  width:6.29rem;
  height:2.76rem;
  margin-top:.16rem;
  background:url('../../assets/img/shadow.png') no-repeat;
  background-size:100% 100%;
}
.project-img img{
  width:6.29rem;
  height:2.60rem;
}
.date{
  color:#94979C;
  font-size:.2rem;
  padding:.1rem 0 .15rem 0;
}
.oInformation{
  border-bottom:1px solid #B3BBC3;
  width:6.27rem;
  margin:0 .3rem;
}
.oInformation:last-child{
  border:none !important;
}
.notice{
  border-radius:16px;
  background:#fff;
  padding-bottom:.2rem;
}
.van-cell--clickable{
  padding-top:.4rem;
  border-radius:16px;
}
.van-cell--clickable::after{
  border:0 !important;
}
.van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after{
  border-width: 0;
}
.collect{
  margin-top:.16rem;
}
.van-cell__title{
  font-size:.36rem;
  color:#444649;
  font-family: SourceHanSerifCN-SemiBold;
}
</style>



// WEBPACK FOOTER //
// src/view/project/index.vue